import { createContext, useContext } from 'react';
import { PathMatch } from 'react-router-dom';

import { Sport } from '__generated__/globalTypes';
import { PathParams } from 'lib/routing/generateSportPath';

type GenerateSportPathFunctionType = <Path extends string>(
  path: Path,
  options?: {
    params?: PathParams<Path>;
    sport?: Sport;
  }
) => string;

export interface SportContext {
  sport: Sport;
  setSport: (sport: Sport) => void;
  generateSportContextPath: GenerateSportPathFunctionType;
  matchAnySportPath: (
    pattern: string,
    pathname: string,
    sport?: Sport
  ) => PathMatch<string> | null;
}

export const SportContext = createContext<SportContext | null>(null);

export const useSportContext = () => useContext(SportContext)!;
